import React from 'react'
import cx from 'classnames'
import { List } from 'immutable'
import { Button, Toggle } from '@driftt/tide-core-legacy'

import Email from '../Email'
import MeetingTripwire from '../MeetingTripwire'

import IconSVG from 'svg-inline-react'

import companyIconLayoutSrc from '!svg-inline?removeTags=true!images/svg/icon_layout.svg'
import simpleLayoutSrc from '!svg-inline?removeTags=true!images/svg/simple_text.svg'
import heroLayoutSrc from '!svg-inline?removeTags=true!images/svg/hero_layout.svg'


import { MarketingEmailLayouts, EditSenderLevels } from 'app/modules/playbook/constants'

import './style.styl'

const EmailTemplateSelect = ({
  onEmailLayoutSelect,
  marketingEmailLayout,
}) => (
  <div className="playbook-sequence-layout-select">
    <header className="playbook-sequence-layout-select-header">Pick an email template</header>
    <div className="playbook-sequence-layout-select-options">
      <div
        onClick={() => onEmailLayoutSelect(MarketingEmailLayouts.SIMPLE)}
        className={cx('playbook-sequence-layout-option', { ['playbook-sequence-layout-option-selected']: marketingEmailLayout === MarketingEmailLayouts.SIMPLE })}
      >
        <div className="playbook-sequence-layout-option-icon layout-option-simple">
          <IconSVG src={simpleLayoutSrc}/>
        </div>
        <div className="playbook-sequence-layout-option-name">Simple Text</div>
      </div>
      <div
        onClick={() => onEmailLayoutSelect(MarketingEmailLayouts.WITH_COMPANY_LOGO)}
        className={cx('playbook-sequence-layout-option', { ['playbook-sequence-layout-option-selected']: marketingEmailLayout === MarketingEmailLayouts.WITH_COMPANY_LOGO })}
      >
        <div className="playbook-sequence-layout-option-icon">
          <IconSVG src={companyIconLayoutSrc}/>
        </div>
        <div className="playbook-sequence-layout-option-name">Logo Styled</div>
      </div>
      <div
        onClick={() => onEmailLayoutSelect(MarketingEmailLayouts.WITH_HERO_IMAGE)}
        className={cx('playbook-sequence-layout-option', { ['playbook-sequence-layout-option-selected']: marketingEmailLayout === MarketingEmailLayouts.WITH_HERO_IMAGE })}
      >
        <div className="playbook-sequence-layout-option-icon">
          <IconSVG src={heroLayoutSrc}/>
        </div>
        <div className="playbook-sequence-layout-option-name">Banner Styled</div>
      </div>
    </div>
  </div>
)

const IndividualSenderToggle = ({
  editSenderLevel,
  onSetEditSenderLevel,
}) => (
  <div className="playbook-edit-sender-toggle-individual">
    <div className="playbook-edit-sender-toggle-label">
      <div className="playbook-edit-sender-toggle-label-title">Edit sender for each email individually</div>
      <div className="playbook-edit-sender-toggle-label-help">{editSenderLevel === EditSenderLevels.LOCAL ? 'currently editing sender for each email' : 'currently editing sender for all emails'}</div>
    </div>
    <Toggle
      className="playbook-table-row-status-toggle"
      checked={editSenderLevel === EditSenderLevels.LOCAL}
      onChange={onSetEditSenderLevel}
    />
  </div>
)

const Sequence = ({
  sequence: { emails },
  onAddClick,
  canSelectTemplate,
  onEmailLayoutSelect,
  marketingEmailLayout,
  isOneTimeMarketingSequencePlaybook,
  isMarketingSequencePlaybook,
  showTripwire,
  setShowTripwire,
  sendTestSequencePending,
  onSendTestSequence,
  editSenderLevel,
  onSetEditSenderLevel,
}) =>
  <div className="playbook-sequence">
    <header className="playbook-title-header">
      <h2>Build your {isMarketingSequencePlaybook ? 'email' : 'sequence'}.</h2>
    {isMarketingSequencePlaybook ?
      <div>
        <p>Choose from one of three templates to get started.</p>
        <p>Need help? We got you. Just <a href="#marketing-email-help">click here</a>.</p>
      </div>
      :
      <div>
        <p>Create a set of emails to send to your leads.</p>
        <p>Need help getting started? We got you. Just <a href="#sequence-help">click here</a>.</p>
      </div>
    }
    </header>

    {List.isList(emails) && emails.size > 1 &&
      <div className="playbook-sequence-extra-edit-options">
        <div className="playbook-sequence-send-test">
          <div>Send yourself the entire sequence as a test</div>
          <Button onClick={onSendTestSequence} disabled={sendTestSequencePending} loading={sendTestSequencePending} type="secondary">Send Test Sequence</Button>
        </div>
        {isMarketingSequencePlaybook &&
          <IndividualSenderToggle
            editSenderLevel={editSenderLevel}
            onSetEditSenderLevel={onSetEditSenderLevel}
          />
        }

      </div>
    }

    {canSelectTemplate &&
      <EmailTemplateSelect
        onEmailLayoutSelect={onEmailLayoutSelect}
        marketingEmailLayout={marketingEmailLayout}/>
    }

    {emails.map((id, index) => <Email key={id} id={id} index={index} setShowTripwire={setShowTripwire} />)}
    {!isOneTimeMarketingSequencePlaybook &&
      <button onClick={onAddClick} className="drift-button">
        Add Email
      </button>
    }
    {showTripwire && <MeetingTripwire setShowTripwire={setShowTripwire} />}
  </div>

export default Sequence



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Sequence/component.js